import { Button, Loader, MultiSelect, Stack, Text } from "@mantine/core";
import { skipToken } from "@reduxjs/toolkit/query";
import { openapi } from "../../openapi";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import {
  selectDrofusEndringerAttributeFilterOptions,
  selectDrofusEndringerAttributeKeys,
  selectDrofusEndringerAttributeOptionsApiArg,
} from "./drofusEndringerSelectors";
import { setDrofusEndringerAttributeKeys } from "./drofusEndringerSlice";

export const DrofusEndringerAttributeFilter: React.FC = () => {
  const dispatch = useAppDispatch();
  const apiArg = useAppSelector(selectDrofusEndringerAttributeOptionsApiArg);
  const selectedKeys = useAppSelector(selectDrofusEndringerAttributeKeys);
  const options = useAppSelector(selectDrofusEndringerAttributeFilterOptions);
  const { isFetching, isError, isSuccess, refetch } =
    openapi.usePostMultiplacerDrofusInterfaceProjectChangeEventAttributeOptionsQuery(
      apiArg ?? skipToken
    );

  return (
    <Stack gap={4}>
      <MultiSelect
        label="Endret attributt"
        placeholder="Alle attributter"
        description="Velg ett eller flere attributter"
        data={options}
        value={selectedKeys}
        onChange={(keys) => dispatch(setDrofusEndringerAttributeKeys(keys))}
        searchable
        clearable
        clearButtonProps={{ "aria-label": "Fjern attributtfilter" }}
        disabled={!apiArg}
        maxDropdownHeight={280}
        nothingFoundMessage={
          isFetching
            ? "Laster attributter…"
            : options.length === 0
              ? "Ingen endrede enkeltattributter med valgte filtre"
              : "Ingen attributter matcher søket"
        }
        rightSection={isFetching ? <Loader size="xs" aria-label="Laster attributter" /> : undefined}
        error={isError ? "Kunne ikke hente attributter" : undefined}
        styles={{ option: { overflowWrap: "anywhere" }, pill: { maxWidth: "100%" } }}
      />
      {apiArg && isSuccess && !isFetching && !isError && options.length === 0 && (
        <Text size="xs" c="dimmed">
          Ingen endrede enkeltattributter med valgte filtre. Nye og fjernede forekomster vises i
          treffene, men har ingen enkeltattributter å filtrere på. Bruk Type for å filtrere disse.
        </Text>
      )}
      {isError && apiArg && (
        <Button size="xs" variant="subtle" onClick={() => void refetch()}>
          Prøv igjen
        </Button>
      )}
    </Stack>
  );
};
